// import { App } from "vue";
// import ltAModel from "./src/main.vue";

// ltAModel.install = (app: App) => {
//   app.component("ltAModel", ltAModel);
// };

// export default ltAModel;

import { withInstall } from "../../utils/install";
import AModel from "./src/main.vue";
AModel.name = "ltAModel";
export const ltAModel = withInstall(AModel);
export default ltAModel;

